export type Locale = 'en' | 'vi';

export const translations = {
  en: {
    // Navigation
    'nav.asset_packs': 'Asset Packs',
    'nav.all_assets': 'All Assets',
    'nav.pro_bundles': 'Pro Bundles',
    'nav.my_library': 'My Library',
    'nav.sign_in': 'Sign In',
    'nav.sign_up': 'Sign Up',
    'nav.sign_out': 'Sign Out',
    'nav.account': 'Account',
    'nav.admin': 'Admin',
    'nav.explore_bundles': 'Explore Bundles',

    // Catalog
    'catalog.search_placeholder': 'Search sprites, packs, tags…',
    'catalog.filter_all': 'All',
    'catalog.filter_free': 'Free',
    'catalog.filter_paid': 'Paid',
    'catalog.engine_all': 'All Engines',
    'catalog.sort_newest': 'Newest First',
    'catalog.sort_price_low': 'Price: Low to High',
    'catalog.sort_price_high': 'Price: High to Low',
    'catalog.no_results': 'No production assets match your criteria.',
    'catalog.download': 'Download',
    'catalog.buy': 'Buy',
    'catalog.page_prev': 'Previous',
    'catalog.page_next': 'Next',
    'catalog.page_of': 'Page {current} of {total}',

    // Asset Detail
    'detail.back_to_catalog': '← Back to Catalog',
    'detail.download_format': 'Download format',
    'detail.preparing_download': 'Preparing download…',
    'detail.one_package_per_download': 'One package per download. You can switch to another download-ready adapter while the entitlement remains valid.',
    'detail.distribution': 'Distribution:',
    'detail.license': 'License:',
    'detail.capabilities': 'Capabilities:',
    'detail.declared_adapters': 'Declared adapters:',
    'detail.download_ready': 'Download-ready:',
    'detail.free_commercial': 'Free (Commercial CC0-compatible)',
    'detail.paid_commercial': 'Commercial Paid',
    'detail.none': 'None',

    // My Library
    'library.title': 'My Library',
    'library.subtitle': 'Assets you own and your active download entitlements.',
    'library.remaining_downloads': 'downloads remaining',
    'library.expires': 'Expires',
    'library.re_download': 'Download Again',
    'library.empty_title': 'No owned assets yet',
    'library.empty_desc': 'Free and paid assets you acquire through the storefront will appear here.',
    'library.browse_catalog': 'Browse Catalog',
    'library.login_required': 'Please sign in to access your asset library.',
    'library.login_button': 'Sign In / Register',

    // Auth Modal / Page
    'auth.sign_in_title': 'Sign in to Picel',
    'auth.sign_up_title': 'Create your Picel account',
    'auth.email_label': 'Email address',
    'auth.password_label': 'Password',
    'auth.sign_in_btn': 'Sign In',
    'auth.sign_up_btn': 'Create Account',
    'auth.switch_to_sign_up': "Don't have an account? Sign up",
    'auth.switch_to_sign_in': 'Already have an account? Sign in',
    'auth.continue_with_google': 'Continue with Google',
    'auth.or_divider': 'or continue with email',
    'auth.close': 'Close',

    // Admin
    'admin.title': 'Storefront & Studio Admin',
    'admin.overview': 'Overview',
    'admin.listings': 'Listings',
    'admin.orders': 'Orders',
    'admin.entitlements': 'Entitlements',
    'admin.subscribers': 'Subscribers',
    'admin.adapters': 'Engine Adapters',
    'admin.access_denied': 'Admin authorization required. Please sign in with an administrator account.',
    'admin.total_listings': 'Total Listings',
    'admin.published_listings': 'Published',
    'admin.total_orders': 'Checkout Intents',
    'admin.total_downloads': 'Downloads Served',
    'admin.total_subscribers': 'Subscribers',
  },
  vi: {
    // Navigation
    'nav.asset_packs': 'Gói Tài Nguyên',
    'nav.all_assets': 'Tất Cả Tài Nguyên',
    'nav.pro_bundles': 'Gói Pro',
    'nav.my_library': 'Thư Viện',
    'nav.sign_in': 'Đăng Nhập',
    'nav.sign_up': 'Đăng Ký',
    'nav.sign_out': 'Đăng Xuất',
    'nav.account': 'Tài Khoản',
    'nav.admin': 'Quản Trị',
    'nav.explore_bundles': 'Khám Phá Gói Pro',

    // Catalog
    'catalog.search_placeholder': 'Tìm kiếm sprite, gói tài nguyên, thẻ…',
    'catalog.filter_all': 'Tất cả',
    'catalog.filter_free': 'Miễn phí',
    'catalog.filter_paid': 'Trả phí',
    'catalog.engine_all': 'Mọi Engine',
    'catalog.sort_newest': 'Mới nhất',
    'catalog.sort_price_low': 'Giá: Thấp đến Cao',
    'catalog.sort_price_high': 'Giá: Cao đến Thấp',
    'catalog.no_results': 'Không tìm thấy tài nguyên nào phù hợp tiêu chí.',
    'catalog.download': 'Tải về',
    'catalog.buy': 'Mua',
    'catalog.page_prev': 'Trước',
    'catalog.page_next': 'Sau',
    'catalog.page_of': 'Trang {current} / {total}',

    // Asset Detail
    'detail.back_to_catalog': '← Quay lại Danh mục',
    'detail.download_format': 'Định dạng gói tải về',
    'detail.preparing_download': 'Đang chuẩn bị tải…',
    'detail.one_package_per_download': 'Mỗi lượt tải nhận 1 gói tương ứng. Bạn có thể chọn adapter khác khi lượt tải còn hiệu lực.',
    'detail.distribution': 'Hình thức:',
    'detail.license': 'Giấy phép:',
    'detail.capabilities': 'Tính năng:',
    'detail.declared_adapters': 'Adapter hỗ trợ:',
    'detail.download_ready': 'Sẵn sàng tải:',
    'detail.free_commercial': 'Miễn phí (Thương mại CC0)',
    'detail.paid_commercial': 'Thương mại Trả phí',
    'detail.none': 'Không có',

    // My Library
    'library.title': 'Thư Viện Của Tôi',
    'library.subtitle': 'Các tài nguyên bạn sở hữu và quyền tải về còn hiệu lực.',
    'library.remaining_downloads': 'lượt tải còn lại',
    'library.expires': 'Hạn sử dụng',
    'library.re_download': 'Tải Lại',
    'library.empty_title': 'Chưa sở hữu tài nguyên nào',
    'library.empty_desc': 'Các tài nguyên miễn phí hoặc trả phí bạn nhận sẽ hiển thị tại đây.',
    'library.browse_catalog': 'Khám Phá Danh Mục',
    'library.login_required': 'Vui lòng đăng nhập để xem thư viện tài nguyên của bạn.',
    'library.login_button': 'Đăng Nhập / Đăng Ký',

    // Auth Modal / Page
    'auth.sign_in_title': 'Đăng nhập vào Picel',
    'auth.sign_up_title': 'Tạo tài khoản Picel mới',
    'auth.email_label': 'Địa chỉ Email',
    'auth.password_label': 'Mật khẩu',
    'auth.sign_in_btn': 'Đăng Nhập',
    'auth.sign_up_btn': 'Tạo Tài Khoản',
    'auth.switch_to_sign_up': 'Chưa có tài khoản? Đăng ký ngay',
    'auth.switch_to_sign_in': 'Đã có tài khoản? Đăng nhập',
    'auth.continue_with_google': 'Tiếp tục với Google',
    'auth.or_divider': 'hoặc tiếp tục với email',
    'auth.close': 'Đóng',

    // Admin
    'admin.title': 'Bảng Quản Trị Cửa Hàng & Studio',
    'admin.overview': 'Tổng Quan',
    'admin.listings': 'Danh Sách',
    'admin.orders': 'Đơn Hàng',
    'admin.entitlements': 'Lượt Tải',
    'admin.subscribers': 'Bản Tin',
    'admin.adapters': 'Engine Adapters',
    'admin.access_denied': 'Yêu cầu quyền quản trị. Vui lòng đăng nhập bằng tài khoản quản trị viên.',
    'admin.total_listings': 'Tổng Số Asset',
    'admin.published_listings': 'Đã Xuất Bản',
    'admin.total_orders': 'Ý Định Mua',
    'admin.total_downloads': 'Lượt Đã Tải',
    'admin.total_subscribers': 'Người Nhận Tin',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
